import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  margin: 15px 0;
  padding: 20px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  background-color: ${COLORS.WHITE};
`;
const CategoriesWrapper = styled.div`
  display: flex;
  grid-gap: 20px;
`;
const ProductColorWrapper = styled.div`
  > h3 {
    span {
      color: #000;
      cursor: pointer;
    }
  }
  > div {
    margin: 15px 0;
    > div {
      display: flex;
      grid-gap: 10px;
      align-items: center;
      flex-wrap: wrap;
      > div {
        width: 120px;
        height: 120px;
      }
    }
    img {
      max-width: 120px;
      box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #ffffff;
      cursor: pointer;
      width: 100% !important;
    }
  }
`;
const FooterButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  grid-gap: 15px;
  > button {
    background-color: ${COLORS.BLACK};
    color: ${COLORS.WHITE};
    text-transform: capitalize;
    :hover {
      background-color: ${COLORS.BLACK};
      opacity: 0.8;
    }
  }
`;

const ProductColors = styled.div`
  display: flex;
  flex-wrap: wrap;
  grid-gap: 10px;
`;

const DecoratingWrapper = styled.div`
  background-color: #fff;
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 15px;
  .title {
    margin: 0;
    padding-bottom: 3px;
    margin-bottom: 7px;
    border-bottom: 1px solid #ccc;
  }

  .decoration-techniques {
    display: flex;
    flex-direction: row;
    grid-gap: 30px;
    margin-top: 10px;

    > div {
      flex: 1;
    }
    .color {
      display: flex;
      flex-direction: row;
      img {
        width: 40px;
        margin-right: 15px;
      }
    }
  }
`;

const Heading = styled.h6`
  font-size: 16px;
  line-height: 32px;
  color: #18191f;
  margin: 0 0 15px;
  span {
    font-size: 14px;
    color: #1594db;
    cursor: pointer;
    text-decoration: underline;
  }
`;

const BoxWrapper = styled.div`
  overflow: auto;
  width: calc(100vw - 55px);
`;

const CategoriesContainer = styled.div`
  /* grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  display: grid; */
  gap: 20px;
  display: flex;
  margin-bottom: 25px;
`;

const CategoryBox = styled.div`
  color: #18191f;
  background-color: #fff;
  padding: 25px 15px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  min-width: 190px;
  .country-name {
    margin-bottom: 0;
  }
  img {
    border-radius: 10px;
    overflow: hidden;
  }
  p {
    font-size: 16px;
    line-height: 32px;
    margin: 0;
    border-top: 1px solid #f0f0f0;
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
`;

const IconWrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  z-index: 1;
  svg {
    color: #fff;
    width: 18px;
  }
`;

export {
  BoxWrapper,
  Container,
  CategoriesWrapper,
  ProductColorWrapper,
  FooterButton,
  ProductColors,
  DecoratingWrapper,
  Heading,
  CategoriesContainer,
  IconWrapper,
  CategoryBox,
};
